import { BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const IconContainer = styled.div`
	position: relative;
	height: 45px;
	width: 74px;
	margin-left: 4px;
`;

const RingWrapper = styled.div`
	position: absolute;
	top: -100px;
	left: -100px;
`;

const FirstRing = styled.div`
	padding: 24px;
	width: 240px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 240px;
	border: 1px solid rgba(234, 236, 240, 0.2);
	border-radius: ${BorderRadius.FULL}px;
`;

const SecondRing = styled(FirstRing)`
	width: 192px;
	height: 192px;
	border: 1px solid rgba(234, 236, 240, 0.3);
`;

const ThirdRing = styled(FirstRing)`
	width: 144px;
	height: 144px;
	border: 1px solid rgba(234, 236, 240, 0.4);
`;

const ModalIconHeaderContainer = styled.div`
	position: relative;
	width: 96px;
	height: 96px;
	padding: 24px;
	border: 1px solid ${BorderColors.Secondary};
	border-radius: ${BorderRadius.FULL}px;
`;

const IconWrapper = styled.div<{ color: string }>`
	height: 48px;
	border-radius: ${BorderRadius.FULL}px;
	width: 48px;
	display: flex;
	align-items: center;
	background-color: ${({ color }) => color};
`;

export { ModalIconHeaderContainer, IconWrapper, FirstRing, IconContainer, SecondRing, ThirdRing, RingWrapper };
